module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.046cb932.svg";